import ApiService from '@/services/core/api.service'

const DashboardService = {
  async getStatistics (query = '') {
    return ApiService.get(`lead-supervisor/dashboard/statistics?${query}`)
  }
}

export default DashboardService
